import Gateway from '../../Gateway.js';

export default class Base {
  static get _path() {
    throw new Error('Path is not defined');
  }

  static get _defaultValue() {
    return '';
  }

  static get provider() {
    return Gateway.autoRequire([this._path]);
  }

  static get() {
    try {
      return this.provider.get();
    } catch (e) {
      Gateway.window.console.warn(e);
      return this._defaultValue;
    }
  }

  static set(value) {
    try {
      Gateway.autoRequire([this._path], (storageProvider) => {
        storageProvider.set(value);
      });
    } catch (e) {
      Gateway.window.console.warn(e);
    }
  }
}
